module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAgMAAABj6rKSAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURUdwTGZmZmRkZGZmZkqSt7IAAAADdFJOUwDfIMe4PcYAAABaSURBVCjPY2AYKoAxAUxxOoDYN8BsdRCbqQzMntsAJ6Ei6iANnBCVYEodYgJYGqIcTEOVg+WhysEaoMrBGmDKgRqayuBOUs+8AWdzXk+As5lqGxDunsYwlAAAHuYVRrH8unMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 1